import { useEffect, useRef, useState, useMemo } from "react";
import { Col, Row, Table } from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Layout from "../../layout";
import { useDownloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import ReactGA from "react-ga4";
import { showPrice } from "utils/utils";

let foodTax = 2.5;
const STORY_HEADERS = [
  {
    prop: "SN",
    title: "SN.",
    cell: (row, rowIndex) => row.SN,
    // isSortable: false,
    // isFilterable: false,
  },
  {
    prop: "orderId",
    title: "Order Id",
    cell: (row) => `${row?.orderId ?? "N/A"}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "bookingId",
    title: "Booking ID",
    cell: (row) => `${row?.bookingId ? row?.bookingId : '-'}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "kotType",
    title: "KOT Type",
    // isSortable: true,
    // isFilterable: true,
    cell: (row) => row?.kotType,
  },
  {
    prop: "paymentDateTime",
    title: "Payment Date & Time",
    // isSortable: true,
    // isFilterable: true,
    cell: (row) => moment(row?.paymentDateTime).format('DD-MM-YYYY HH:mm'),
  },
  {
    prop: "amount",
    title: "Amount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => showPrice(row?.amount)
  },
  {
    prop: "discount",
    title: "Discount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => showPrice(row?.discount)
  },
  {
    prop: "paymentAmount",
    title: "Payment Amount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => showPrice(row?.paymentAmount)
  },
  {
    prop: "paymentMode",
    title: "Payment Mode",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row?.paymentMode
  },
  {
    prop: "transactionId",
    title: "Transaction ID / Ref",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row?.transactionId
  },
  {
    prop: "paymentStatus",
    title: "Payment Status",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row?.paymentStatus
  },
  {
    prop: "balance",
    title: "Balance",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => showPrice(row?.balance)
  },
];

// Then, use it in a component.
export default function FoodPaymentReport() {

  const { userDetail } = useSelector(authenticationSeletor);
  const [tableData, setTableData] = useState([]);
  const [exportFilter, setExportFilter] = useState({
    startDate: (() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 1);
      return d;
    })(),
    endDate: new Date(),
  });
  const [searchBookingId, setSearchBookingId] = useState('');
  const [searchOutletId, setSearchOutletId] = useState('');
  const [debouncedBookingId, setDebouncedBookingId] = useState('');
  const [debouncedOutletId, setDebouncedOutletId] = useState('');

  const tableRef = useRef();
  const { access_token } = useSelector((state) => state.authentication);


  const getDataHandler = async () => {
    const payload = {
      fromdate: moment(exportFilter.startDate).format("YYYY-MM-DD 00:00:00"),
      todate: moment(exportFilter.endDate).format("YYYY-MM-DD 23:59:59"),
      propertyId: userDetail?.propertyId,
    };
    if (searchBookingId) {
      payload.booking_id = searchBookingId
    }
    if (searchOutletId) {
      payload.orderId = searchOutletId
    }
    try {
      const res = await Services.property.getFoodOrdersPaymentReport(payload)
      if (res.status === 200) {
        const resultWithSN = res.data.data.map((item, index) => ({
          ...item,
          SN: index + 1,
        }));
        setTableData(resultWithSN);
      }
    } catch (error) { }
  };


  useEffect(() => {
    getDataHandler();
  }, [exportFilter.startDate, exportFilter.endDate, debouncedBookingId, debouncedOutletId])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedBookingId(searchBookingId);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchBookingId]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedOutletId(searchOutletId);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchOutletId]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "food_reporting" });
  }, []);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Food_Orders_Details",
    sheet: "Food_Orders_Details",
  });


  // const exportHandler = async () => {
  //   const payload = {
  //     fromdate: moment(exportFilter.startDate).format("YYYY-MM-DD 00:00:00"),
  //     todate: moment(exportFilter.endDate).format("YYYY-MM-DD 23:59:59"),
  //     propertyId: userDetail?.propertyId,
  //   };
  //   if (searchBookingId) {
  //     payload.booking_id = searchBookingId;
  //   }
  //   if (searchOutletId) {
  //     payload.orderId = searchOutletId;
  //   }

  //   fetch(`https://staging.rrooms.in/rrooms/api/rrooms-property/food-payment-report-export`, {
  //     method: "POST",
  //     headers: {
  //       "Authorization": `Bearer ${access_token}`,
  //       "Content-Type": "application/json"
  //     },
  //     body: JSON.stringify(payload)
  //   })
  //     .then(res => res.blob())
  //     .then(blob => {
  //       const url = URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = 'Food-Order-Payment-Report.xlsx';
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       URL.revokeObjectURL(url);
  //     });
  // };


  return (

    <Row className="justify-content-end" style={{ marginTop: '-36px' }}>
      <DatatableWrapper
        body={tableData}
        headers={STORY_HEADERS}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 20,
            options: [5, 10, 15, 20, 50, 100, 300],
          },
        }}
        defaultSortProp=""
        defaultSortOrder="asc"
      >
        <div className="col-lg-8 mb-2">
          <div className="row-sm d-flex justify-content-end">
            <div className="col-lg-2">
              <input
                type="text"
                className="field-control sm border-dark"
                value={searchBookingId}
                onChange={(e) => {
                  setSearchBookingId(e.target.value);
                  setSearchOutletId('')
                }}
                placeholder="Search By Booking Id" />
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="field-control sm border-dark"
                value={searchOutletId}
                onChange={(e) => {
                  setSearchOutletId(e.target.value);
                  setSearchBookingId('')
                }}
                placeholder="Search By Order Id" />
            </div>
            <div className="col-lg-1">
              <PaginationOptions />
            </div>
          </div>
        </div>
        <div className="col-lg-12 pt-2">
          <Table className="food-report" ref={tableRef}>
            <TableHeader />
            <TableBody />
          </Table>
        </div>
        <Col className="d-flex flex-col justify-content-end align-items-end paginationFoodReport">
          <Pagination />
        </Col>
      </DatatableWrapper>
    </Row>


  );
}
